import { useState } from "react";
import {
  TextField,
  IconButton,
  Box,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Search, Refresh } from "@mui/icons-material";
import moment from "moment";

const DateSearchComponent = ({ onSearch }) => {
  const [startDate, setStartDate] = useState(
    moment().subtract(30, "days").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // ✅ Mobile detection

  const handleSearch = () => {
    if (startDate && endDate) {
      onSearch(startDate || null, endDate || null);
    } else if (startDate) {
      onSearch(startDate || null, endDate || null);
    } else if (endDate && !startDate) {
      const calculatedStartDate = moment(endDate)
        .subtract(3, "months")
        .format("YYYY-MM-DD");

      onSearch(calculatedStartDate, endDate);
    }
  };

  const handleReset = () => {
    const defaultStartDate = moment().subtract(30, "days").format("YYYY-MM-DD");
    const defaultEndDate = moment().format("YYYY-MM-DD");

    setStartDate(defaultStartDate);
    setEndDate(defaultEndDate);
    // setStartDate("");
    // setEndDate("");

    onSearch(null, null, defaultStartDate, defaultEndDate);
  };

  return (
    <Box
      display="flex"
      // flexDirection={isMobile ? "column" : "row"} // ✅ Stack on mobile
      alignItems={isMobile ? "stretch" : "center"}
      justifyContent={isMobile ? "flex-start" : "flex-end"}
      gap={isMobile ? 0.5 : 1} // ✅ More gap on mobile for better spacing
      // width="100%"
    >
      {/* Start Date */}
      <TextField
        name="startDate"
        id="startDate"
        size="small"
        label="Start Date"
        type="date"
        value={startDate}
        onChange={(e) => setStartDate(e.target.value)}
        InputLabelProps={{ shrink: true }}
        variant="outlined"
        fullWidth={isMobile} // ✅ Full width on mobile
      />

      {/* End Date */}
      <TextField
        size="small"
        name="endDate"
        id="endDate"
        label="End Date"
        type="date"
        value={endDate}
        onChange={(e) => setEndDate(e.target.value)}
        InputLabelProps={{ shrink: true }}
        variant="outlined"
        fullWidth={isMobile} // ✅ Full width on mobile
      />

      {/* Search + Reset Buttons */}
      <Box
        display="flex"
        flexDirection="row"
        justifyContent={isMobile ? "flex-end" : "center"}
        gap={isMobile ? 0.5 : 0} // ✅ Less gap on mobile
      >
        {/* Search Icon Button */}
        <Tooltip title="Search">
          <IconButton
            color="primary"
            onClick={handleSearch}
            size={isMobile ? "small" : "medium"} // ✅ Smaller buttons on mobile
            sx={{
              p: isMobile ? "0px" : "4px", // ✅ Less padding on mobile
            }}
          >
            <Search />
          </IconButton>
        </Tooltip>

        {/* Reset Icon Button */}
        <Tooltip title="Reset">
          <IconButton
            color="secondary"
            onClick={handleReset}
            size={isMobile ? "small" : "medium"}
            sx={{
              p: isMobile ? "0px" : "4px", // ✅ Less padding on mobile
            }}
          >
            <Refresh />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default DateSearchComponent;


// import { useState } from "react";
// import { TextField, IconButton, Box, Tooltip } from "@mui/material";
// import { Search, Refresh } from "@mui/icons-material";
// import moment from "moment";

// const DateSearchComponent = ({ onSearch }) => {
//   const [startDate, setStartDate] = useState(
//     moment().subtract(30, "days").format("YYYY-MM-DD")
//   );
//   const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));

//   const handleSearch = () => {
//     if (startDate && endDate) {
//       onSearch(startDate || null, endDate || null);
//     } else if (startDate) {
//       onSearch(startDate || null, endDate || null);
//     } else if (endDate && !startDate) {
//       // Only endDate is selected
//       const calculatedStartDate = moment(endDate)
//         .subtract(3, "months") // Subtract 6 months from endDate
//         .format("YYYY-MM-DD");

//       // Call onSearch with calculated startDate and endDate
//       onSearch(calculatedStartDate, endDate);
//     }
//   };

//   const handleReset = () => {
//     const defaultStartDate = moment().subtract(30, "days").format("YYYY-MM-DD");
//     const defaultEndDate = moment().format("YYYY-MM-DD");
//     setStartDate(defaultStartDate);
//     setEndDate(defaultEndDate);
//     setStartDate("");
//     setEndDate("");
//     onSearch(null, null, defaultStartDate, defaultEndDate); // Reset the filters
//   };



//   return (
//     <Box
//       display="flex"
//       flexDirection="row"
//       alignItems="center"
//       justifyContent="flex-end"
//       gap={1}
//     >
//       <TextField
//         name="startDate"
//         id="startDate"
//         size="small"
//         label="Start Date"
//         type="date"
//         value={startDate}
//         onChange={(e) => setStartDate(e.target.value)}
//         InputLabelProps={{ shrink: true }}
//         variant="outlined"
//       />
//       <TextField
//         size="small"

//         name="endDate"
//         id="endDate"
//         label="End Date"
//         type="date"
//         value={endDate}
//         onChange={(e) => setEndDate(e.target.value)}
//         InputLabelProps={{ shrink: true }}
//         variant="outlined"
//       />

//       <Box display="flex"
//         flexDirection="row"
//         alignItems="center"
//       // ml={-1} 

//       >

//         {/* Search Icon Button */}
//         <Tooltip title="Search">
//           <IconButton color="primary" onClick={handleSearch}>
//             <Search />
//           </IconButton>
//         </Tooltip>

//         {/* Reset Icon Button */}
//         <Tooltip title="Reset">
//           <IconButton color="secondary" onClick={handleReset}>
//             <Refresh />
//           </IconButton>
//         </Tooltip>
//       </Box>
//     </Box>
//   );
// };

// export default DateSearchComponent;

// import { useState } from "react";
// import { TextField, Button, Box } from "@mui/material";

// const DateSearchComponent = ({ onSearch }) => {
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");

//   const handleSearch = () => {
//     // Call the parent component's onSearch function with the dates
//     onSearch(startDate || null, endDate || null);
//   };

//   return (
//     <Box
//       display="flex"
//       flexDirection="row"
//       alignItems="center"
//       justifyContent="flex-end"
//       gap={2}
//       p={2}
//     >
//       <TextField
//         size="small"
//         label="Start Date"
//         type="date"
//         value={startDate}
//         onChange={(e) => setStartDate(e.target.value)}
//         InputLabelProps={{ shrink: true }}
//         variant="outlined"
//       />
//       <TextField
//         size="small"
//         label="End Date"
//         type="date"
//         value={endDate}
//         onChange={(e) => setEndDate(e.target.value)}
//         InputLabelProps={{ shrink: true }}
//         variant="outlined"
//       />
//       <Button variant="contained" color="primary" onClick={handleSearch}>
//         Search
//       </Button>
//     </Box>
//   );
// };

// export default DateSearchComponent;
